import {Action, Actions, Card} from 'platform/components';
import {HStack, Show, ThemeIconKey, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {map} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish, suffixTestId} from 'shared/web';

import {IntegrationNotification} from '../IntegrationNotification/IntegrationNotification';

export interface IntegrationCardAction {
  key?: string | Nullish;
  title: string;
  icon?: ThemeIconKey;
  isLoading?: boolean;
  isDisabled?: boolean;
  onClick: (event: React.MouseEvent) => void;
}

interface IntegrationCardNotification {
  level?: 'info' | 'warning' | 'error' | 'success' | Nullish;
  content?: string | Nullish;
}

interface IntegrationCardProps {
  title: ReactNode;
  actions?: IntegrationCardAction[];
  notification?: IntegrationCardNotification;
  children?: ReactNode;
  isInactive?: boolean;
  'data-testid'?: string;
}

export function IntegrationCard(props: IntegrationCardProps) {
  const actions = map<IntegrationCardAction, Action>((action) => ({
    type: 'button',
    title: action.title,
    leftIcon: action.icon,
    variant: 'outlined',
    isLoading: action.isLoading,
    isDisabled: action.isDisabled,
    onClick: action.onClick,
  }))(props.actions ?? []);
  const showNotification =
    isNotNilOrEmpty(props.notification?.level) || isNotNilOrEmpty(props.notification?.content);

  return (
    <Card
      colorStripe={props.isInactive ? 'neutral' : 'black'}
      variant={props.isInactive ? 'inlineGrey' : 'inlineWhite'}
    >
      <VStack spacing={3}>
        <HStack spacing={4} align="center" justify="space-between" minWidth={100}>
          {props.title}
          <Show when={isNotNilOrEmpty(actions)}>
            <Actions size="small" actions={actions} data-testid={suffixTestId('actions', props)} />
          </Show>
        </HStack>
        <Show when={showNotification}>
          <IntegrationNotification
            level={props.notification?.level}
            content={props.notification?.content}
            data-testid={suffixTestId('notification', props)}
          />
        </Show>
        {props.children}
      </VStack>
    </Card>
  );
}
